import "core-js/modules/es6.regexp.to-string";
import _toConsumableArray from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
//
//
//
//
import echarts from 'echarts';
export default {
  props: {
    values: {
      type: Array,
      required: true // 确保 values 是必需的

    }
  },
  mounted: function mounted() {
    this.initChart();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    initChart: function initChart() {
      this.chart = echarts.init(this.$refs.myChart);
      this.setChartOptions();
    },
    setChartOptions: function setChartOptions() {
      var data = this.values; // 使用 props 中的 values

      var maxValue = Math.max.apply(Math, _toConsumableArray(data));
      var minValue = Math.min.apply(Math, _toConsumableArray(data));
      console.log('最大值', maxValue, minValue);
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          data: data.map(function (_, index) {
            return (index + 1).toString();
          }),
          // 根据 values 的长度生成 x 轴标签
          axisTick: {},
          axisLine: {
            lineStyle: {
              color: 'rgba(127, 132, 139, 1)' // 设置 x 轴线颜色

            }
          },
          axisLabel: {
            color: 'rgba(127, 132, 139, 1)' // 设置 x 轴标签颜色

          }
        }],
        yAxis: [{
          type: 'value',
          axisLine: {
            lineStyle: {
              color: 'rgba(127, 132, 139, 1)' // 设置 y 轴线颜色

            }
          },
          axisLabel: {
            color: 'rgba(127, 132, 139, 1)' // 设置 y 轴标签颜色

          } // splitLine: {
          //   lineStyle: {
          //     color: 'rgba(127, 132, 139, 1)' // 设置 y 轴分割线颜色
          //   }
          // }

        }],
        series: [{
          name: this.$t('电压'),
          type: 'bar',
          barWidth: '20px',
          data: data.map(function (value) {
            return {
              value: value,
              itemStyle: {
                color: value == maxValue ? 'rgba(255, 125, 0, 1)' : value == minValue ? 'rgba(14, 197, 192, 1)' : 'rgba(25, 190, 107, 1)'
              }
            };
          })
        }]
      };
      this.chart.setOption(option);
    },
    handleResize: function handleResize() {
      if (this.chart) {
        this.chart.resize();
      }
    }
  },
  watch: {
    values: {
      deep: true,
      // 如果 values 是数组，使用深度监听
      handler: function handler(newVal) {
        this.setChartOptions(); // 重新设置图表选项
      }
    }
  }
};